import { useEffect } from "react";
import { useI18n } from "@/i18n/I18nProvider";

export default function Cookies() {
  const { t } = useI18n();
  useEffect(() => {
    const id = "iubenda-js";
    if (!document.getElementById(id)) {
      const s = document.createElement("script");
      s.id = id;
      s.async = true;
      s.src = "https://cdn.iubenda.com/iubenda.js";
      document.body.appendChild(s);
    }
  }, []);
  return (
    <div className="container mx-auto px-6 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-4">{t('legal.cookies.title', 'Cookie Policy')}</h1>
      <p className="text-gray-700 mb-4">{t('legal.cookies.intro', 'Read our updated Cookie Policy and manage your cookie preferences.')}</p>
      <a
        href="https://www.iubenda.com/privacy-policy/54070684/cookie-policy"
        className="iubenda-white iubenda-embed text-primary underline"
        title={t('legal.cookies.title', 'Cookie Policy')}
      >
        {t('legal.cookies.open_link', 'Open the Cookie Policy')}
      </a>
      <div className="py-4 text-sm text-gray-600">
        {t('legal.cookies.fallback_prefix', 'You can also')}{" "}
        <a className="text-primary underline" href="https://www.iubenda.com/privacy-policy/54070684/cookie-policy" target="_blank" rel="noreferrer">
          {t('legal.cookies.fallback_link', 'open the cookie policy on iubenda.com')}
        </a>.
      </div>
    </div>
  );
}
